export const pages = {
  auth: {
    login: {
      title: 'Log in'
    },
    confirmation: {
      title: 'Email confirmation',
      description:
        'We have sent a code to {email}. Delivery may take up to one minute.'
    },
    verifyEmail: {
      title: 'Change password'
    },
    reset: {
      title: 'Change password'
    },
    otp: {
      title: 'Email confirmation',
      description:
        'We have sent a code to {email}. Delivery may take up to one minute.'
    },
    register: {
      title: 'Register as {role}'
    },
    invite: {
      title: 'Welcome to Live Bright Connect',
      description: 'Choose your profile type'
    }
  },
  notification: {
    title: 'Notifications',
    notFound: 'You have no notifications yet.',
    description:
      'You can view new artist requests in the “Artists” section of your profile.'
  },
  loyalty: {
    inputLabel: 'Your link:',
    registered: 'Registered',
    followed_link: 'Followed the link',
    inputDescription: 'To invite an artist, send them this registration link.',
    artist: {
      title: 'Site invitation',
      description:
        'An artist counts as invited once she completes registration via your link.'
    },
    club: {
      title: 'Loyalty programme',
      note: 'An artist counts as invited once she completes registration via your link.',
      description: 'Get artists without paying commission!',
      text: '👯‍♀️ Held a casting and the artist was not a fit? Someone is finishing a contract? Send her your personal link.',
      content:
        'When an artist registers with your link, she is added to your tally. 📌 For every 5 artists you receive one commission-free contract for one calendar month. Even if an artist chooses another club, she will still count towards your total. ‼️ To take part, your club must complete its profile and be visible in search. ⚡ Share the link, grow the platform and benefit right away.'
    }
  },
  language: {
    title: 'Languages',
    description: 'Select the platform language',
    options: {
      ru: 'Russian',
      en: 'English',
      uk: 'Ukrainian',
      it: 'Italian',
      de: 'German',
      tr: 'Turkish',
      es: 'Spanish'
    }
  },
  profilePage: {
    techSupport: 'Care service',
    privacy: 'Terms and privacy',
    artist: {
      work: 'Work in the club',
      infoEditSection: 'Editing',
      infoAppSection: 'Application',
      personalInfo: 'About me',
      portfolio: 'Portfolio',
      invitationAndRequests: 'Requests and invitations',
      hideProfile: 'Hide account',
      loyaltyLink: 'Invite a friend'
    },
    club: {
      clubInfoSection: 'Club information',
      artistsSection: 'Artists',
      artistHiring: 'Artist hiring',
      loyaltyProgram: 'Loyalty programme',
      editingSection: 'Editing',
      clubInfo: 'About',
      conditions: 'Terms',
      approvedArtists: 'Approved artists',
      requestsAndInvitations: 'Requests and invitations',
      applicationSection: 'Application'
    }
  },
  portfolioPage: {
    title: 'Portfolio',
    warnNotPublished:
      'CV not published. Complete your portfolio to publish it.',
    warnfillPortfolio: 'Complete portfolio',
    warnf: 'Complete portfolio',
    warnFillSection:
      'Complete this section to increase your chances of receiving invitations.'
  },
  profileInfo: {
    club: {
      title: 'About'
    },
    artist: {
      title: 'About'
    }
  },
  clubTerms: {
    title: 'Terms',
    description:
      'Please complete every step in full. It affects how attractive your listing is to artists. Contact support if you encounter any difficulties.',
    progressSteps: {
      schedule: 'Club work schedule',
      contractTerms:
        'Minimum contract length, artist schedule, tickets, airport transfer',
      payments:
        'Payments: rate, guarantee, full service, topless, go-go, deposit, show, tips, consumption, crazy menu',
      workConditions:
        'Type of consumption. Choreographer. Photo shoots. Poles. Quantity.',
      housing: 'Accommodation information. Photos.',
      penalties: 'Penalty grid',
      photo: 'Club photos',
      video: 'Club videos'
    }
  },
  clubEmployers: {
    title: 'Approved artists',
    tabs: {
      pending: 'Pending',
      onContract: 'On contract'
    }
  },
  requestAndInvitation: {
    title: 'Requests and invitations'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Club working hours',
        popups: {
          title: 'Working hours'
        },
        changeAllWorkTimes: 'Change all working hours'
      },
      contractTerms: {
        title: 'Club working conditions',
        form: {
          minimalContractTerm: {
            label: 'Minimum contract term',
            unit: 'Weeks'
          },
          artistsSchedule: {
            label: 'Artist work schedule'
          }
        }
      },
      payments: {
        title: 'Payments',
        rateFieldDescription:
          'If you have a single rate, fill in only one of the fields.'
      },
      workConditions: {
        title: 'Club working conditions',
        form: {
          noExperienceEmployment: 'Hiring artists without experience',
          additionalInfo: {
            label: 'Additional club information',
            placeholder:
              'Share any promotions, bonuses or other details that might interest artists',
            description: 'Enter at least 100 characters'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement: 'Enter a dress code item',
            description:
              'Select the dress code for artists in your club. Add any missing items.'
          }
        }
      },
      housing: {
        title: 'Accommodation information'
      },
      penalties: {
        title: 'Penalties',
        description: 'Add your own items if they are not in the provided list.'
      },
      photo: {
        title: 'Club photos',
        description: 'Upload photos of the club. You can make changes later.',
        options: {
          hallNoGuests: 'Photo of an empty hall',
          hallWithGuests: 'Photo of the hall with guests',
          privateRooms: 'Photo of private rooms',
          scene: 'Photo of the stage'
        }
      },
      video: {
        title: 'Club videos',
        description: 'Upload videos of the club. You can make changes later.',
        options: {
          ClubTour: 'Video of an empty hall',
          EventVideo: 'Video of the hall with guests',
          WorkingHours: 'Video of the stage'
        }
      }
    },
    artist: {
      work: {
        title: 'Work Experience',
        addWorkPlace: 'Add workplace',
        notHaveWorkExperience: 'Continue without experience'
      },
      language: {
        title: 'Languages',
        languageProfinience: 'Foreign language proficiency'
      },
      parametres: {
        title: 'Measurements'
      },
      about: {
        title: 'About me',
        description:
          'Write something about yourself that would interest clubs.',
        textAreaDescription: 'Enter at least 100 characters',
        textAreaPlaceholder: 'Enter text'
      },
      video: {
        title: 'Video',
        videoForHostesVacancy: 'Upload a runway video',
        videoForGogoVacancy:
          'Upload a video of you dancing for strip and go-go vacancies'
      },
      photo: {
        title: 'Photos',
        description: 'Upload photos without filters or retouching.',
        FaceNoMakeup: 'Model — face without make-up.',
        FaceWithMakeup: 'Face with make-up.',
        FreePose: 'Photo of the model in a relaxed pose.',
        FullBodyOnHeels: 'Full-length photo in heels.',
        LingerieOrSwimsuit: 'Photo of the model in lingerie or a swimsuit.',
        selectMainPhoto: 'Choose main photo'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'The artist already works at the club',
      incompleted: 'To send invitations you must complete your profile 100%.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Request your contract end date from the club.',
      clubSetLastWorkDate:
        'The club has set your last working day at this club.',
      clubNotHiring:
        'You cannot send a request because the club is not hiring.',
      pendingRequest: 'You cannot send more than one request within 48 hours.',
      haveContract:
        'You cannot send a request because you have an active contract.',
      hidden:
        'You cannot send a request because your profile is hidden from search.',
      incompleted:
        'You cannot send a request because you have not completed your profile.'
    }
  },
  notFoundWorkItem: {
    title: 'This invitation or request no longer exists.',
    description:
      'We’re sorry, but this page does not exist. Please return to the homepage.'
  },
  notFoundCurrentWork: {
    title: 'No active contract',
    description:
      'You do not currently have an active contract. Go to the search page and submit a request to start one.'
  },
  clubFullProfile: {
    clubVideo: 'Club video',
    clubPhoto: 'Club photo',
    clubHousingPhoto: 'Accommodation photo',
    minimalContractDuration: 'Minimum contract, weeks',
    artistWorkSchedule: 'Work schedule',
    paymentFrequescyMessage: 'Artist consumption payouts — once per'
  },
  privacyPolicy: {
    title: 'Terms of service and privacy policy'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Invite a manager to the chat',
      managerIsInChat: 'The manager is in the chat',
      manageRequestPending: 'The manager will join soon'
    },
    admin: {
      assistanceProvided: 'Assistance provided',
      openDirectChat: 'Open direct chat',
      openWhatsApp: 'Open WhatsApp',
      phoneNumberNotAvailable: 'Phone number not available'
    }
  }
};
